import React from "react";
import {
  Select,
  Button,
  Space,
  Row,
  Col,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import creditStore from "../store/CreditStore";
import DistributorStore from "../store/DistributorStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
class CreditDetails extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.selectDistributor = this.selectDistributor.bind(this);
    this.creditStore = new creditStore(this);
    this.distributorStore = new DistributorStore(this);



    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      customerCompId: "",
      creditType: "",
      sendInvoice: "",
      distributor: "",
      distCompanyId: null,
      distributorType: "",
      status: "",
      company_name: "",
      companyVal_Lab: "",
      emailId: "",
      listUpdated: 0,


      companyId: "",
      editType: "",
      dType: "",
      isadmin: "",

      email: "",

      creditType: "",

      createdBy: "",

      openAccountForm: false,
      companyIdForEdit: "",
      listDataUpdate: false,
      showStatusConfirm: false,
      isActive: false,

    };



    this.columns = [
      {
        // title: "Account Name",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "companyName",
        width: "15%",
        ellipsis: true,
      },
      {
        title: context.translate("_COMPANY_"),
        dataIndex: "creditAdded",
        width: "15%",
        ellipsis: true,
      },
      {
        // title: "Contact Phone",
        title: context.translate("_CREDIT_EXPIRY_"),
        dataIndex: "creditDeducted",
        width: "15%",
        ellipsis: true,
      },

    ];




  }







  async componentDidUpdate(prvProp, prevState) {

  }

  async componentDidMount() {

    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.setState({ companyId: this.props.getUserData().userCompanyId });
    }


    await this.distributorStore.distributorList();
    await this.setState({ listUpdated: 1 }); //need to reload data

    this.setState({ pageSize: 50 });
  }


  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    console.log(pagination, "paadsadsfsg");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch({
      distCompanyId: null,
      creditType: null
    });
  }

  async selectDistributor(value, option) {
    console.log(value)
    await this.creditStore.getDistributorCompanies({ companyId: value });

    await this.setState({
      distCompanyId: value,
      currentPage: 1,
    });
    console.log(this.state.distCompanyId)
    // await this.setState({ distributorType: [{value:value,label:option.createdBy}] });

    await this.handleSearch({
      distCompanyId: value,
      creditType: this.state.creditType
    });
  }





  async handleSearch({ distCompanyId, creditType }) {
    console.log(distCompanyId)
    this.setState({ loading: true });
    console.log(this.state.distCompanyId)
    await this.creditStore.getVehicleCreditRecords({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      distCompanyId: distCompanyId,
      creditType: creditType

      // companyId: 358,
    });



    await this.setState({ listUpdated: 1 }); //need to reload data
  }









  render() {
    //console.log('in render1')

    return (
      <>
        <div style={{ padding: 0 }}>
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
              <Row className="headerFixed" style={{ height: "50px" }}>
                <Col span={12}>
                  {/* <div className="heading">Account List</div> */}
                  <div className="heading">
                    {this.context.translate("_CREDIT_DETAILS_")}
                  </div>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <Space style={{}}>
                    {/* <AddButton
                link="/useradd"
                title={this.context.translate("_ADD_")}
              /> */}

                    <Space
                      style={{
                        float:
                          this.context.locale.direction == "ltr"
                            ? "right"
                            : "left",
                      }}
                    >
                      {/* <AddButton
                  link="/addaccount"
                  title={this.context.translate("_ADD_")}
                /> */}
                      <Button type="primary"

                        onClick={() =>

                          this.props.navigate('/creditlist')
                        }
                      >
                        <i class="bi bi-credit-card-2-back-fill"
                          style={{ marginInlineEnd: "5px" }}
                        ></i>


                        {this.context.translate("_CREDIT_LIST_")}
                      </Button>
                      <Button type="primary"
                        onClick={() =>

                          this.props.navigate('/creditrequestlist')
                        }
                      >

                        <i class="bi bi-credit-card-2-back"
                          style={{ marginInlineEnd: "5px" }}
                        ></i>

                        {this.context.translate("_CREDIT_REQUESTED_")}
                      </Button>

                    </Space>
                  </Space>
                </Col>
              </Row>
            )}
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
              <Row className="listInputRow">
                <Col span={16}>
                  <Space>
                    {Number(this.props.getUserData().isadmin) === -1 && (
                      <Select
                        style={{
                          width: 250,
                        }}
                        fieldNames={{ label: "name", value: "companyId" }}
                        value={
                          this.state.distCompanyId
                            ? this.state.distCompanyId
                            : null
                        }
                        // placeholder=" Select Distributor1"
                        placeholder={this.context.translate(
                          "_SELECT_ADMIN_USER_"
                        )}
                        onChange={async (val, option) => {
                          await this.selectDistributor(val, option);

                        }}
                        optionFilterProp="children"
                        options={this.distributorStore?.distributors}
                      />
                    )}

                    {/* {Number(this.props.getUserData().isadmin) === -1 && (
                    <Select
                      style={{
                        width: 180,
                      }}
                      fieldNames={{ label: "name", value: "companyId" }}
                      value={
                        this.state.customerCompId
                          ? this.state.customerCompId
                          : null
                      }
                      placeholder={this.context.translate("_CUSTOMER_COMPANY_")}
                      optionFilterProp="children"
                      onSelect={async (value) => {
                        await this.setState({
                          customerCompId: value,
                          currentPage: 1,
                        });
                        await this.handleSearch(value);
                      }}
                      options={this.creditStore?.distributorsComps}
                    />
                  )} */}



                    <Select
                      style={{
                        width: 150,
                      }}
                      placeholder={this.context.translate(
                        "_CREDIT_TYPE_"
                      )}
                      value={
                        this.state.creditType !== "" ? this.state.creditType : undefined
                      }
                      optionFilterProp="children"
                      onSelect={async (value) => {
                        await this.setState({ creditType: value, currentPage: 1 });
                        await this.handleSearch({ distCompanyId: this.state.distCompanyId, creditType: value });
                        await this.setState({ listUpdated: 1 });
                      }}
                      options={[
                        {
                          value: 0,
                          label: "All",
                          // label:this.context.translate("_ALL_")
                        },
                        {
                          value: "New",
                          label: this.context.translate("_NEW_")
                          // label:this.context.translate("_EXPIRED_")
                        },
                        {
                          value: "Renew",
                          label: this.context.translate("_RENEW_")
                          // label:this.context.translate("_EXPIRINGSOON_")
                        },

                      ]}
                    />

                  </Space>
                </Col>
              </Row>
            )}
          <ListTable
            currentPage={this.state.currentPage}
            total={this.creditStore?.total}
            columns={this.columns}
            dataSource={this.creditStore?.credits}
            pageSize={this.state.pageSize}
            // pagination={{

            //   total:this.creditStore.total || 0

            // }}
            loading={this.creditStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>


      </>
    );
  }
}
CreditDetails.contextType = StoreContext;
export default observer(withRouter(CreditDetails));
